<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="dedication"><a id="_idTextAnchor001"></a>For Benjy</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// QueenForADay2.vue?c46a6234